import { Button, CircularProgress, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import modalEmitter from '../ModalComponent/modalEmitter'

type Props = {
  onConfirm: () => Promise<boolean>
  onCancel: () => void
}

export function CommentDeleteConfirmModalBody({ onConfirm, onCancel }: Props) {
  const [isDeleting, setIsDeleting] = useState(false)

  const handleCancel = () => {
    if (isDeleting) return
    onCancel()
    modalEmitter.emitCloseModal()
  }

  const handleConfirm = async () => {
    if (isDeleting) return
    setIsDeleting(true)
    try {
      const ok = await onConfirm()
      if (ok) {
        modalEmitter.emitCloseModal()
      }
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Stack gap={2}>
      <Typography variant="black-14-normal">
        Комментарий будет удалён без возможности восстановления.
      </Typography>
      <Stack direction="row" gap={2} justifyContent="flex-end">
        <Button variant="follow" disabled={isDeleting} onClick={handleCancel}>
          Отмена
        </Button>
        <Button variant="danger" disabled={isDeleting} onClick={() => void handleConfirm()}>
          {isDeleting ? (
            <Stack direction="row" alignItems="center" spacing={1}>
              <CircularProgress size={16} color="inherit" />
              <span>Удаление…</span>
            </Stack>
          ) : (
            'Удалить'
          )}
        </Button>
      </Stack>
    </Stack>
  )
}
